// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import ThemeController from "./theme_controller"
import MarkdownPreviewController from "./markdown_preview_controller"
import MermaidController from "./mermaid_controller"
import GridBgController from "./grid_bg_controller"
import KeyboardController from "./keyboard_controller"
import DividerController from "./divider_controller"
application.register("hello", HelloController)
application.register("theme", ThemeController)
application.register("markdown-preview", MarkdownPreviewController)
application.register("mermaid", MermaidController)
application.register("grid-bg", GridBgController)
application.register("keyboard", KeyboardController)
application.register("divider", DividerController)
